import Icon from 'veui/components/Icon'
import { IconLock } from 'dls-icons-vue'

Icon.register('lock', IconLock)
